import React, { useReducer, useContext } from 'react'
import { createContext } from 'react'
import { SLIDE_INC, SLIDE_DEC, SLIDE_TYPE, START, END } from './actions'

const GlobalStateContext = createContext()
const GlobalDispatchContext = createContext()

const globalReducer = (state, action) => {
  switch (action.type) {
    case SLIDE_INC:
      return {
        ...state,
        current: state.current + 1,
      }
    case SLIDE_DEC:
      return {
        ...state,
        current: state.current - 1,
      }
    case SLIDE_TYPE:
      return {
        ...state,
        slideType: action.slideType,
      }
    case START:
      return {
        ...state,
        current: 2,
        slideType: 'next',
      }
    case END:
      return {
        ...state,
        current: 5,
      }
    default: {
      throw new Error(`Reducer Error unable to reduce action ${action.type}`)
    }
  }
}
export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(globalReducer, {
    current: 1,
    slideType: 'next',
  })
  return (
    <GlobalDispatchContext.Provider value={dispatch}>
      <GlobalStateContext.Provider value={state}>{children}</GlobalStateContext.Provider>
    </GlobalDispatchContext.Provider>
  )
}
export const useGlobalStateContext = () => useContext(GlobalStateContext)
export const useGlobalDispatchContext = () => useContext(GlobalDispatchContext)
